module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_mobile-60c27ad89cbbb3363cfdc5b277102b3e.webp";